window.refreshTranscription = function() {
    var procedureToRemoveFromReport = undefined;
    var procedureToAddToReport = undefined;
    var selectedUrgency = undefined;

    window.addLocks(new URLSearchParams(window.location.search).get('fc') * 1, transcriptionLockUIDs);

    $("#tabs").tabs();

    $('#validatedTab').empty();

    $('#emptyPage').hide();

    $('#loading').hide();

    //Initial setup editor
    if ($('div#divOrderReport').length > 0) {
        ReportSharedFunctions.InitTextEditor(Model);
    }

    var pollG2Timeout;

    window.reportGUID = Model.GUID;
    var validatedReport = Model.Validated;
    var readOnly = Model.ReadOnly;

    $('#dialogReloadProcCombFile').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        title: htmlDecode(window.Resources.ReloadFile)
    });

    $('#divPopupConfirmationEmpty').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: { my: "center", at: "center", of: '#contentView' },
        title: htmlDecode(window.Resources.EmptyReport)
    });

    $('#reloadPage').on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        $('#dialogReloadProcCombFile').dialog('open');
    });

    $('#btnOkReloadProcCombFileDialog').on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        $('#dialogReloadProcCombFile').dialog('close');
        
        ReportSharedFunctions.OnReloadRemoveAddedProceduresInReport();

        ReportSharedFunctions.LaunchEmptyPacsIntegration();
        closeActiveFile(false);
    });

    $('#btnCloseReloadProcCombFileDialog').on('click', function (e) {
        $('#dialogReloadProcCombFile').dialog('close');
    });

    $('.procedureItem,.procedureItemWithRating, .procedureItemWithRatingv1, .physicianContactInfo').tooltip({
        tooltipClass: 'jqueryTooltip',
        //track: true,
        content: function () {
            return $(this).prop('title');
        },
        position: {
            my: "left top",
            at: "left bottom"
        },
        close: function (event, ui) {
            $('.jqueryTooltip').remove();
        },
        show: function (event, ui) {
            $('.jqueryTooltip').remove();
        }
    });

    $('.infoHoverPopup').hide();

    $('.validation').hide();
    $('.required').hide();

    $('#submitBottom span.datetime').each(function (i, y) {
        var unformattedModDate = $(this).html();
        var m = moment(unformattedModDate, "MM/DD/YYYY hh:mm:ss A");
        if (m.isValid()) {
            $(this).html(m.calendar());
        }
    });

    $('textarea#ReportContent').autosize();

    $('ul#urgentList li').on('click', function (e) {
        if (!$('div#subPageContent').hasClass('disabled')) {
            if (!$(this).hasClass('default')) {
                $('ul#urgentList li.default').removeClass('default');
                $(this).addClass('default');
                selectedUrgency = $(this).attr('id');
            }
        }
    });

    $('#btnOkEditAndDeleteSpeechDocument').on('click', function (e) {
        closeActiveSpeech().done(function (e) {
            clearTimeout(window.pollG2Timeout);
            launchSpeechXHR?.abort();

            $('#editableContent').val("true");
            //DELETE SPEECH DOCUMENT
            $.ajax({
                type: 'POST',
                data: {
                    GUID: reportGUID,
                    Order_UID: Model.OrderID
                },
                async: false,
                url: '/legacy/Reports/DeleteG2SpeechDocument',
                success: function (data) {
                }
            });

            $('#divEditAndDeleteSpeechDocument').dialog('close');
            tinyMCE.activeEditor.focus();
        });
    });

    $('input#btnCloseFile').on('click', function (e) {
        $('body').off('click', 'ul.listFound li');
        ReportSharedFunctions.SendORUOnClose(forOrder_ProcedureUIDs);
        closeActiveFile(true);
    });

    var SaveAndCloseFunctionality = function(supervisor_uid, printReport)
    {
        $('#btnSaveAndCloseFile').attr('disabled', true);

        if (typeof printReport == "undefined") {
            printReport = false;
        }

        if(typeof selectedUrgency === 'undefined')
            selectedUrgency = null;

        $.ajax({
            type: 'POST',
            url: '/legacy/Locks/CheckLockFileBeforeSaving',
            data: { LockType: LockType.Report, RecordID: $('span#lockableRecordID').text() },
            async: false,
            dataType: 'json',
            success:
                function (data) {
                    if (data.Done) {
                        let reportContent = $('textarea#ReportContent').attr('value');
                        reportContent = reportContent?.replace(/<div>(.*?)<\/div>/gm, "$1<br>"); // TinyMCE handles <div>'s with a newline, but this doesn't happen everywhere (for example when rendering a report). So replacing those div's with <br> tags to fix this.
                        var transcriptionRemark = $('textarea#TranscriptionRemark').val();
                        var orderID = Model.OrderID;

                        var orderDocumentsInformation = [];
                        $('.scannedOrderHolder').each(function (index, element) {
                            var orderID = $(element).find('.scannedOrderID').val();
                            var rotated = $(element).find('.scannedOrderRotated').val();
                            var degrees = $(element).find('.scannedOrderDegrees').val();

                            var subDocument = {
                                Rotated: rotated,
                                Degrees: degrees
                            };

                            if (!orderDocumentsInformation[index]) {
                                orderDocumentsInformation[index] = {
                                    ID: orderID,
                                    SubDocuments: []
                                };
                            }

                            orderDocumentsInformation[index].SubDocuments.push(subDocument);
                        });

                        $.ajax({
                            type: "POST",
                            url: '/legacy/Reports/SaveTranscriptionReport',
                            async: false,
                            data: {
                                Order_UID: orderID,
                                Report_UID: viewbagreport_UID,
                                ReportContent: reportContent,
                                RemoveOrder_Procedure_UIDs: removeOrder_ProcedureUIDs,
                                AddOrder_Procedure_UIDs: addOrder_ProcedureUIDs,
                                Supervisor_UID: supervisor_uid,
                                GUID: reportGUID,
                                TranscriptionRemark: transcriptionRemark,
                                SendForValidation: gValidate,
                                PrintReport: printReport,
                                SelectedUrgency: selectedUrgency,
                                OrderDocumentsInformation: orderDocumentsInformation
                            },
                            success: function (data) {
                                $('#btnSaveAndCloseFile').removeAttr('disabled');

                                if (data.PrintFail == true) {
                                    $('#divPrintFailDialog p#printMessage').html(data.Message);
                                    $('#divPrintFailDialog').dialog('open');
                                }
                                ReportSharedFunctions.LaunchEmptyPacsIntegration();
                                closeActiveFile(true, true);
                            }
                        });
                    }
                    else if (!data.Done) {
                        $('#btnSaveAndCloseFile').removeAttr('disabled');

                        $('#divNotLockedDialog').dialog('open');
                    }
                }
        });
    }

    var gSave = false;
    var gValidate = false;

    //save
    var SaveAndClose = function (supervisor_uid, printReport) {
        SaveAndCloseFunctionality(supervisor_uid, printReport);
    };

    var SaveAfterConfirmation = function (ok) {
        if (isAssistentRadiologist) {
            ShowPopupChooseSupervisor();
        }
        else {
            SaveAndClose(null);
        }
    }

    $('button#btnNOKPopupConfirmation' + viewbagUniquePrefix).on('click', function (e) {
        SaveAfterConfirmation(false);
    });

    $('button#btnOKPopupConfirmation' + viewbagUniquePrefix).on('click', function (e) {
        SaveAfterConfirmation(true);
    });

    var CheckReportContentBeforeSaving = function (dontCheckEmpty, printReport) {
        if (!showEmptyReportConfirmation || dontCheckEmpty)
        {
            return true;
        }
        else {
            var reportContent = $('textarea#ReportContent').attr('value').replace(/\r?\n/g, '<br>');
            reportContent = reportContent.replace(/<br>/gi, '');
            reportContent = reportContent.replace(/<br \/>/gi, '');
            reportContent = reportContent.replace(/<br\/>/gi, '');
            reportContent = reportContent.replace(/&nbsp;/gi, '');
            reportContent = $.trim(reportContent);
            if (reportContent == "") {
                $('#toConfirmActionText').text(htmlDecode(window.Resources.toSave));
                $('#toConfirmAction').val(1);
                $('#divPopupConfirmationEmpty').data('printReport', printReport).dialog('open');
                return false;
            }
            return true;
        }
    };

    $('#btnConfirmEmptyOk').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();

        var printReport = $('#divPopupConfirmationEmpty').data('printReport');

        $('#divPopupConfirmationEmpty').dialog('close');

        $('#btnSaveAndCloseFile').trigger('click', [false, true, printReport]);

        $('#divPopupConfirmationEmpty').dialog('close');
    });

    //save
    $('input#btnSaveAndCloseFile').on('click', function (e, fromEOL, dontCheckEmpty, printReport) {
        gSave = true;
        gValidate = false;

        //CHECK G2
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        if (typeof fromEOL == "undefined") {
            fromEOL = false;
        }
        if (!fromEOL && userHasSpeechRecognition && useG2Speech && !dontCheckEmpty) {

            clearTimeout(pollG2Timeout);

            $('#btnSaveAndCloseFile').attr('disabled', true);
            closeActiveSpeech().done(function (e) {
                $('#btnSaveAndCloseFile').removeAttr('disabled');
                $.ajax({
                    type: "GET",
                    url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                    async: false,
                    data: {
                        GUID: reportGUID,
                        Order_UID: Model.OrderID
                    },
                    timeout: 15000,
                    success: function (data) {
                        clearTimeout(pollG2Timeout);
                        if (data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists)) {
                            if (data.ReportGUID) {
                                reportGUID = data.ReportGUID;
                            }
                            $('#startSpeechRecognition').removeClass('disabled');
                            tinymce.activeEditor.setContent(data.Result);
                        }
                        else if (data.ErrorG2) {
                            $('#startSpeechRecognition').removeClass('disabled');
                            alert(data.ErrorMessage);
                            return false;
                        }
                        else if (data.Error) {
                            console.log('Error getting G2speechdocumentOnSaveAndClose');
                            $('#startSpeechRecognition').removeClass('disabled');
                        }

                        if (CheckReportContentBeforeSaving(dontCheckEmpty, printReport, false)) {
                            if (isAssistentRadiologist) {
                                ShowPopupChooseSupervisor(printReport, false);
                            }
                            else {
                                SaveAndClose(null, printReport, false);
                            }
                        }
                    }
                });
            }).error(function(e) {
                $('#btnSaveAndCloseFile').removeAttr('disabled');
            });

        }
        else {
            if (CheckReportContentBeforeSaving(dontCheckEmpty, printReport, false)) {
                if (isAssistentRadiologist) {
                    ShowPopupChooseSupervisor(printReport, false);
                }
                else {
                    SaveAndClose(null, printReport, false);
                }
            }
        }
        $('body').off('click', 'ul.listFound li');
    });

    //Save and Print
    $('input#btnSavePrintAndSendFile').on('click', function () {
        $('input#btnSaveAndSendFile').trigger('click',[false, false, true]);
    });

    //validate
    $('input#btnSaveAndSendFile').on('click', function (e, fromEOL, dontCheckEmpty, printReport) {
        gSave = false;
        gValidate = true;

        //CHECK G2
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        if (typeof fromEOL == "undefined") {
            fromEOL = false;
        }
        if (typeof printReport == "undefined") {
            printReport = false;
        }

        if (!fromEOL && userHasSpeechRecognition && useG2Speech && !dontCheckEmpty) {

            clearTimeout(pollG2Timeout);

            $('#btnSaveAndCloseFile').attr('disabled', true);
            closeActiveSpeech().done(function (e) {
                $('#btnSaveAndCloseFile').removeAttr('disabled');
                $.ajax({
                    type: "GET",
                    url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                    async: false,
                    data: {
                        GUID: reportGUID,
                        Order_UID: Model.OrderID
                    },
                    timeout: 15000,
                    success: function (data) {
                        clearTimeout(pollG2Timeout);
                        if (data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists)) {
                            if (data.ReportGUID) {
                                reportGUID = data.ReportGUID;
                            }
                            $('#startSpeechRecognition').removeClass('disabled');
                            tinymce.activeEditor.setContent(data.Result);
                        }
                        else if (data.ErrorG2) {
                            $('#startSpeechRecognition').removeClass('disabled');
                            alert(data.ErrorMessage);
                            return false;
                        }
                        else if (data.Error) {
                            console.log('Error getting G2speechdocumentOnSaveAndClose');
                            $('#startSpeechRecognition').removeClass('disabled');
                        }

                        if (CheckReportContentBeforeSaving(dontCheckEmpty, printReport)) {
                            if (isAssistentRadiologist) {
                                ShowPopupChooseSupervisor(printReport);
                            }
                            else {
                                SaveAndClose(null, printReport);
                            }
                        }
                    }
                });
            }).error(function(e) {
                $('#btnSaveAndSendFile').removeAttr('disabled');
            });

        }
        else {
            if (CheckReportContentBeforeSaving(dontCheckEmpty, printReport)) {
                if (isAssistentRadiologist) {
                    ShowPopupChooseSupervisor(printReport);
                }
                else {
                    SaveAndClose(null, printReport);
                }
            }
        }
    });

    $('span.validation').hide();

    $('span.validationAreaGeneral').hide();
    $('span.validationAreaLeft').hide();
    $('span.validationAreaRight').hide();

    $('h3.panelHeaderPassive').next().hide();

    var m = moment($('span#age').html(), "DD/MM/YYYY");
    var mReportDate = moment(Model.OrderDateOfImplementation, "DD/MM/YYYY");
    if (m.isValid() && mReportDate.isValid()) {
        $('span#age').html(mReportDate.diff(m, 'years'));
    }

    var m = moment($('dd#age').html(), "DD/MM/YYYY");
    if (m.isValid()) {
        $('dd#age').html(moment().diff(m, 'years'));
    }

    $('a[href="#"]').on('click', function (e) {
        e.preventDefault();
    });

    $('select').each(function (e) {
        if ($(this).attr('value') != null) {
            $(this).val($(this).attr('value'));
        }
    });

    $('textarea').each(function (e) {
        if ($(this).attr('value') != null) {
            $(this).val($(this).attr('value'));
        }
    });

    $('#divPopupConfirmation' + viewbagUniquePrefix).dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: "#contentView",
        position: { my: "left top", at: "left+15 top+30", of: '#contentView' }
    });

    $('#divViewReportDialog' + viewbagUniquePrefix).dialog({
        autoOpen: false,
        resizable: false,
        modal: false,
        draggable: true,
        appendTo: "#contentView",
        title: $("<div/>").html(window.Resources.Preview + ' ' + window.Resources.Report).text(),
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        sticky: 'false'
    });

    $('input[type=radio]').on('change', function (e) {
        var thisVal = $(this).val();
        $(this).attr('checked', true);
        $('input[type=radio][name=' + $(this).attr('name') + ']').each(function (i, y) {
            if ($(y).val() != thisVal) {
                $(y).removeAttr('checked');
            }
        });
    });

    //new
    $('input#viewHistoryPatient').on('click', function (e) {
        useFilingCabinet("/Patients/OrderHistory/" + Model.PatientID);
    });

    $('input#loadOrder').on('click', function (e) {
        useFilingCabinet("/Orders/Detail/" + Model.OrderID);
    });

    $('body').on('mouseenter', 'div#orderHistoryTimeline li ul, div#orderHistoryTimeline li.yearItem span.amount', function (e) {
        $(this).parent().addClass('hoverItem');
    });
    $('body').on('mouseleave', 'div#orderHistoryTimeline li ul, div#orderHistoryTimeline li.yearItem span.amount', function (e) {
        $(this).parent().removeClass('hoverItem');
    });

    $('div#contentView').show();

    var activeTimeline;

    var ToggleTimeline = function (e) {
        if (!$('#subPageContent').hasClass('loadedForToggleTimeline')) {
            $('#subPageContent').addClass('loadedForToggleTimeline');
            if (showTimelineOnBottomOfReport) {
                activeTimeline = true;
            }
            else {
                activeTimeline = false;
            }
        }
        if (activeTimeline || typeof activeTimeline == 'undefined') {
            $('#toggleTimeline' + viewbagUniquePrefix).addClass('active');
            $('#orderHistoryContainer').show();
            $('#yearHistoryContainer').show();
            $('#noOrderHistoryContainer').show();
        }
    else {
            $('#toggleTimeline' + viewbagUniquePrefix).removeClass('active');
            $('#orderHistoryContainer').hide();
            $('#yearHistoryContainer').hide();
            $('#noOrderHistoryContainer').hide();
        }

        ResizeOrderReportFields();
    };

    $('body').on('click', '#toggleTimeline' + viewbagUniquePrefix, function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            activeTimeline = false;
        }
        else {
            activeTimeline = true;
        }
        ToggleTimeline();
    });

    var NoOrderHistory = function (e) {
        var divNoTimeLine = '<div id="noOrderHistoryTimeline">';
        divNoTimeLine += '<a class="toggleTimelineBtn" id="toggleTimeline' + viewbagUniquePrefix + '">HIDE/SHOW TIMELINE</a>';
        divNoTimeLine += '<div id="noOrderHistoryContainer">' + htmlDecode(window.Resources.NoOrderHistoryFound2) + '</div>';
        divNoTimeLine += '</div>';
        $('div#submitBottom').prepend(divNoTimeLine);
        var orderHistoryTab = '<div class="clearfix boxSizing" style="margin: 10px 10px 0px 10px; width: Calc(100% - 20px);">';
        orderHistoryTab += '<h3 class="insideTabHeader" style="margin-bottom: 0px !important">' + htmlDecode(window.Resources.NoOrderHistoryFound2) + '</h3>';
        orderHistoryTab += '</div>';
        $('#historyTab').html(orderHistoryTab);
        ToggleTimeline();
    }

    var scrollingOverOrders = false;

    $('body').on('click', '#backToOrderHistoryOverview', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('div#backToOrderHistoryOverview').hide();
        $('div#historyTabPreviousReport').hide();
        $('table#orderHistoryTable').show();
        $('#filterOrderHistoryInTab').show();
    });

    var SetOrderHistory = function (FilterModality, FilterProcedures) {
        var divTimeLine = '<div id="orderHistoryTimeline">';
        divTimeLine += '<a class="toggleTimelineBtn" id="toggleTimeline' + viewbagUniquePrefix + '">HIDE/SHOW TIMELINE</a>';
        divTimeLine += '<div class="timelineContainer" id="orderHistoryContainer"><ul class="timelineList" id="orderHistoryList"></ul></div>';
        divTimeLine += '<div class="timelineContainer" id="yearHistoryContainer"><ul class="timelineList" id="yearHistoryList"></ul></div>';
        divTimeLine += '</div>';
        $('div#submitBottom').prepend(divTimeLine);

        var amountInWidth = $('.timelineContainer').width() / 200;

        var orderHistoryTab = '<div class="clearfix boxSizing" style="margin: 10px 10px 0px 10px; width: Calc(100% - 20px);">';
        orderHistoryTab += '<h3 class="insideTabHeader" style="margin-bottom: 0px !important">' + htmlDecode(window.Resources.History2) + '<span id="amountOfHistoryFound"></span></h3>';
        orderHistoryTab += '<div id="backToOrderHistoryOverview">' + htmlDecode(window.Resources.BackToOverview) + '</div>';
        orderHistoryTab += '<div id="previousReportLoading" style="text-align: center; display: none;"><img src="./Content/img/loading.gif"/></div>';
        orderHistoryTab += '<ul id="filterOrderHistoryInTab" class="clearfix">&nbsp;</ul>';
        orderHistoryTab += '<table class="regularTable boxSizing" id="orderHistoryTable" style="margin-top: 20px !important;">';
        orderHistoryTab += '<tbody>';
        orderHistoryTab += '<tr>';
        orderHistoryTab += '<th class="pr15 center">' + htmlDecode(window.Resources.Date) + '</th>';
        orderHistoryTab += '<th class="pr75">' + htmlDecode(window.Resources.Procedures) + '</th>';
        orderHistoryTab += '<th class="pr10 center">' + htmlDecode(window.Resources.AmountOfReports) + '</th>';
        orderHistoryTab += '</tr>';

        $.each(orderHistory.Items, function (i, x) {
            var toAppend = '<li class="timelineItem ' + x.Year + '">';
            var ulToAppend = '<ul>';
            var amountOfReports = new Array();
            $.each(x.OrderProcedures, function (i, proc) {
                ulToAppend += '<li id="fromOrderHistoryTimeLine' + x.Order_UID + '_' + proc.OrderHasProcedure_UID + '" class="procedureItem ' + (proc.StatusIndicator == 5 ? "controlProcedure" : (proc.StatusIndicator == 1 ? "startedProcedure" : (proc.StatusIndicator == 2 ? "finishedProcedure" : (proc.StatusIndicator == 3 ? "correctionProcedure" : (proc.StatusIndicator == 4 ? "canceledProcedure" : ""))))) + '" style="background-color: ' + proc.Color + '"';
                ulToAppend += ' title="' + proc.Modality_Text + ' - ' + proc.Description + '<br>' + proc.Room_Text + ' - <b>' + proc.Radiologist_Text + ' (R)</b> - ' + proc.Technician_Text + ' (T)">';
                ulToAppend += '<span class="hidden number">' + proc.OrderHasProcedure_UID + '</span>';
                if (proc.Report_UID != 0 && proc.Report_UID != null) {
                    if (amountOfReports.indexOf(proc.Report_UID) == -1) {
                        amountOfReports.push(proc.Report_UID);
                    }
                    ulToAppend += '<span class="procedureReportUID hidden">' + proc.Report_UID + '</span>';
                }
                ulToAppend += '<span class="insideProcedureItemContainer"><b>' + proc.Modality_Text + '</b> ' + proc.Code + '</span>';
                if (proc.Validated) {
                    ulToAppend += '<span class="procHasReport" title=' + window.Resources.Validated + '>V</span>';
                }
                else if (proc.Dictated) {
                    ulToAppend += '<span class="procHasReport" title=' + window.Resources.Dictated + '>D</span>';
                }
                ulToAppend += '</li>';
            });
            ulToAppend += '</ul>';
            toAppend += ulToAppend;
            toAppend += '<span class="hidden orderID">' + x.Order_UID + '</span>';
            toAppend += "<span class='date'>(" + x.DateTime + ")</span>";
            toAppend += "<span class='titlePopup hidden'>" + x.Title + " (" + x.DateTime + ")</span>";
            if (x.HasReport == true) {
                toAppend += '<span class="hidden orderReportID">' + x.Report_UID + '</span>';
            }
            toAppend += '</li>';
            $('ul#orderHistoryList').append(toAppend);

            orderHistoryTab += '<tr class="orderHistoryItem" id="fromOrderHistoryTab' + x.Order_UID + '_0">';
            orderHistoryTab += '<td class="pr15 center">' + x.DateTime + '</td>';
            orderHistoryTab += '<td class="pr75">' + ulToAppend + '</td>';
            orderHistoryTab += '<td class="pr10 center">' + amountOfReports.length + '</td>';
            orderHistoryTab += '</tr>';
        });

        if (orderHistory.Items.length > 0) {
            orderHistoryTab += '</tbody>';
            orderHistoryTab += '</table>';
        }

        orderHistoryTab += '</div>';
        orderHistoryTab += '<div style="display: none; margin-top: 10px;" id="historyTabPreviousReport">';
        orderHistoryTab += '</div>';

        $('#historyTab').empty();
        $('#historyTab').append(orderHistoryTab);

        $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
            tooltipClass: 'jqueryTooltip',
            //track: true,
            content: function () {
                return $(this).prop('title');
            },
            position: {
                my: "left top",
                at: "left bottom"
            },
            close: function (event, ui) {
                $('.jqueryTooltip').remove();
            },
            show: function (event, ui) {
                $('.jqueryTooltip').remove();
            }
        });

        var totalWidth = 0;
        $.each($('ul#orderHistoryList li.timelineItem'), function (i, y) {
            totalWidth += $(this).outerWidth();
            if (i == $('ul#orderHistoryList li.timelineItem').length - 1) {
                totalWidth += $('div#orderHistoryContainer').width() - $(this).outerWidth();
            }
        });

        $('#orderHistoryList').css('width', totalWidth);

        var filterHistoryInTab = '<li class="filterHistory">';
        filterHistoryInTab += '<input type="checkbox" class="checkModality check-box" id="checkModalityFromTab' + $('#uniquePrefix').text() + '" ' + (FilterModality ? 'checked="true"' : '') + ' /><span>' + $('<div/>').html(window.Resources.SameModality).text() + '</span></li>';

        filterHistoryInTab += '<li class="filterHistory">';
        filterHistoryInTab += '<input type="checkbox" class="checkProcedures check-box" id="checkProceduresFromTab' + $('#uniquePrefix').text() + '" ' + (FilterProcedures ? 'checked="true"' : '') + ' /><span>' + $('<div/>').html(window.Resources.SameProcedures).text() + '</span></li>';
        $('#filterOrderHistoryInTab').append(filterHistoryInTab);

        var checkModality = '<li class="filterHistory">';
        checkModality += '<input type="checkbox" class="checkModality check-box" id="checkModality' + $('#uniquePrefix').text() + '" ' + (FilterModality ? 'checked="true"' : '') + ' /><span>' + $('<div/>').html(window.Resources.SameModality).text() + '</span></li>';
        $('ul#yearHistoryList').append(checkModality);

        var checkProcedures = '<li class="filterHistory">';
        checkProcedures += '<input type="checkbox" class="checkProcedures check-box" id="checkProcedures' + $('#uniquePrefix').text() + '" ' + (FilterProcedures ? 'checked="true"' : '') + ' /><span>' + $('<div/>').html(window.Resources.SameProcedures).text() + '</span></li>';
        $('ul#yearHistoryList').append(checkProcedures);

        var totalHistoryUnFiltered = 0;
        var totalHistoryFiltered = 0;
        $.each(orderHistory.OrdersInYears, function (i, x) {
            totalHistoryUnFiltered += x.OriginalAmount;
            totalHistoryFiltered += x.Amount;
            var toAppend = '<li class="yearItem">';
            if (x.Amount != x.OriginalAmount) {
                toAppend += '<span class="title">' + x.Year + '</span><span class="amount">&nbsp;(' + x.Amount + ' ' + $("<div/>").html(window.Resources.of).text() + ' ' + x.OriginalAmount + ')</span>';
            }
            else {
                toAppend += '<span class="title">' + x.Year + '</span><span class="amount">&nbsp;(' + x.Amount + ')</span>';
            }
            $('ul#yearHistoryList').append(toAppend);

        });


        var totalHistoryFilteredAmount = ' ';
        if (totalHistoryFiltered == totalHistoryUnFiltered) {
            totalHistoryFilteredAmount += '(' + totalHistoryUnFiltered + ')';
        }
        else {
            totalHistoryFilteredAmount += '(' + totalHistoryFiltered + '/' + totalHistoryUnFiltered + ')';
        }

        $('#amountOfHistoryFound').text(totalHistoryFilteredAmount);
        $('#amountOfHistoryInTabLink').text(totalHistoryFilteredAmount);

        $("#orderHistoryContainer").mCustomScrollbar({
            horizontalScroll: true,
            theme: "dark",
            scrollButtons: {
                enable: true
            },
            mouseWheelPixels: 180,
            advanced: {
                updateOnBrowserResize: true,
                autoExpandHorizontalScroll: true
            }
        });

        $('#yearHistoryList').css('width', (150 * (orderHistory.OrdersInYears.length)) + 2 + "px");


        var showPreviousPartialReportReq = function (Order_UID, OrderProcedure_UID, SameOrder) {
            var req = $.ajax({
                type: 'POST',
                data: {
                    Order_UID: Order_UID,
                    OrderProcedure_UID: OrderProcedure_UID,
                    SameOrder: SameOrder,
                    FromValidatedReport: validatedReport
                },
                url: "/legacy/Reports/ShowPreviousPartialReport"
            });

            return req;
        };



        $('li.timelineItem ul li').hoverIntent(
            {
                sensitivity: 3,
                interval: 200,
                timeout: 200,
                over: function (e) {
                    e.stopImmediatePropagation();
                    if (!scrollingOverOrders) {
                        var titlePopup;
                        var reportID;

                        var procedureReportUID = $(this).find('span.procedureReportUID').text();
                        titlePopup = $(this).find('.insideProcedureItemContainer').text() + ' ' + $(this).parent().parent().find('span.date').text();
                        ReportSharedFunctions.ShowPreviousReportPopup(procedureReportUID, titlePopup, viewbagUniquePrefix, false, true);

                        tinymce.activeEditor.focus();
                    }
                },
                out: function (e) { }
            }
        );
        ToggleTimeline();
    }

    $('#divPopupPreviousReport' + viewbagUniquePrefix).dialog({
        autoOpen: false,
        resizable: false,
        modal: false,
        appendTo: '#contentView',
        position: { my: "right top", at: "right-25 top+125", of: '#contentView' },
        close: function (event, ui) {
            tinymce.activeEditor.focus();
        }
    });

    $('body').on('click', 'li.filterHistory', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        var chkBox;

        if ($(e.target).hasClass('check-box')) {
            return false;
        }
        else {
            chkBox = $(this).find('input[type=checkbox]');
        }

        chkBox.prop("checked", !chkBox.prop("checked"));
        chkBox.attr("checked", chkBox.prop('checked'));

        if (chkBox.hasClass('checkProcedures')) {
            $('input.checkProcedures').prop('checked', chkBox.prop('checked'));
        }
        else if (chkBox.hasClass('checkModality')) {
            $('input.checkModality').prop('checked', chkBox.prop('checked'));
        }

        GetOrderHistory();
    });

    $('body').on('click', 'li.filterHistory input.check-box', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        var chkBox = $(this);

        if (chkBox.hasClass('checkProcedures')) {
            $('input.checkProcedures').prop('checked', chkBox.prop('checked'));
        }
        else if (chkBox.hasClass('checkModality')) {
            $('input.checkModality').prop('checked', chkBox.prop('checked'));
        }

        GetOrderHistory();
    });

    $('body').on('click', 'li.yearItem', function (e) {
        e.stopImmediatePropagation();
        var year = $(this).find('span.title').text();
        var firstOfYear = $('ul#orderHistoryList').find('li.' + year).first();
        if (firstOfYear.length !== 0) {
            var offset = firstOfYear[0].offsetLeft;
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", offset);
        }
    });

    var orderHistory;
    var orderHistoryFound = false;

    var OrderHistoryCall = function (FilterModality, FilterProcedures) {
        var req = $.ajax({
            type: 'GET',
            //async: false,
            data: {
                Patient_UID: Model.PatientID,
                Order_UID: Model.OrderID,
                CheckedFilterModality: FilterModality,
                CheckedFilterProcedure: FilterProcedures,
                Partial: true,
                PartialReport_UID: viewbagreport_UID,
                PartialProcedure_IDs: forOrder_ProcedureUIDs
            },
            url: '/legacy/Reports/GetOrderHistoryTimeLine',
            dataType: 'json'
        });

        return req;
    };

    var GetOrderHistory = function (e) {
        orderHistory = null;
        orderHistoryFound = false;
        $('ul#orderHistoryList').hide();
        var loader = $('<div><img src="/Content/img/loading.gif"/></div>');
        $('div#orderHistoryContainer').prepend(loader);

        var historyErrors = false;

        var reqHis = OrderHistoryCall().done(function () {
            if (reqHis.responseJSON.AllOk) {
                orderHistoryFound = true;
                orderHistory = reqHis.responseJSON.OrderHistory;
            }
            else {
                historyErrors = true;
            }

            if (orderHistoryFound) {
                $('#orderHistoryTimeline').remove();

                if (historyErrors) {
                    NoOrderHistory();
                }
                else {
                    SetOrderHistory();
                }
            }
            else {
                NoOrderHistory();
            }
            $('ul#orderHistoryList').show();
            ResizeOrderReportFields();
        });
    }

    GetOrderHistory();

    var startDragg = 0;
    $('body').on('mousedown', '#orderHistoryTimeline #orderHistoryContainer', function (e) {
        scrollingOverOrders = true;
        try {
            startDragg = -mcs.left;
        } catch (e) { }
        e.preventDefault();
        $(this)
            .data('down', true) // a flag indicating the mouse is down
            .data('x', e.clientX) // the current mouse down X coord
            .data('scrollLeft', this.scrollLeft); // the current scroll position
        return false;
    });

    $('body').on('mousedown', '#orderHistoryTimeline #yearHistoryContainer', function (e) {
        e.preventDefault();
        $(this)
            .data('down', true) // a flag indicating the mouse is down
            .data('x', e.clientX) // the current mouse down X coord
            .data('scrollLeft', this.scrollLeft); // the current scroll position
        return false;
    });

    $('body').on('mouseup', function (e) {
        var containerOrders = $('#orderHistoryTimeline #orderHistoryContainer');
        $(containerOrders).data('down', false);
        scrollingOverOrders = false;
        var containerYears = $('#orderHistoryTimeline #yearHistoryContainer');
        $(containerYears).data('down', false);
    });

    $('body').on('mousemove', function (e) {
        var containerOrders = $('#orderHistoryTimeline #orderHistoryContainer');
        if (containerOrders.data('down') == true) {
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", startDragg + (containerOrders.data('x') - e.clientX), {
                scrollInertia: 10
            });
        }
        var containerYears = $('#orderHistoryTimeline #yearHistoryContainer');
        if (containerYears.data('down') == true) {
            containerYears[0].scrollLeft = containerYears.data('scrollLeft') + containerYears.data('x') - e.clientX;
        }
    });

    //Firefox
    $('#orderHistoryTimeline #orderHistoryContainer').bind('DOMMouseScroll', function (e) {
        if (e.originalEvent.detail > 0) {
            ScrollRightOrders();
        } else {
            ScrollLeftOrders();
        }
        return false;
    });
    $('#orderHistoryTimeline #yearHistoryContainer').bind('DOMMouseScroll', function (e) {
        if (e.originalEvent.detail > 0) {
            ScrollRightYears();
        } else {
            ScrollLeftYears();
        }
        return false;
    });

    var ScrollLeftOrders = function (e) {
        try {
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", "-=180", {
                scrollInertia: 10
            });
        }
        catch (e) { }
    }
    var ScrollLeftYears = function (e) {
        $("#orderHistoryTimeline #yearHistoryContainer").finish();
        $("#orderHistoryTimeline #yearHistoryContainer").animate({
            scrollLeft: "-=150"
        }, 450);
    }

    var ScrollRightOrders = function (e) {
        try {
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", "+=180", {
                scrollInertia: 10
            });
        }
        catch (e) { }
    }
    var ScrollRightYears = function (e) {
        $("#orderHistoryTimeline #yearHistoryContainer").finish();
        $("#orderHistoryTimeline #yearHistoryContainer").animate({
            scrollLeft: "+=150"
        }, 450);
    }
    setTimeout(function () {
        if ($('div#subContent').find('div#submitBottom').length > 0) {
            $('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());
        }
        //ResizeTopSubField();
        $("#orderHistoryContainer").mCustomScrollbar("update");
    }, 300);
    //end new

    $('#dialogConfirmRemoveProcedure').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: "#contentView",
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        title: htmlDecode(window.Resources.RemoveFromThisReport)
    });

    $('#dialogConfirmAddProcedure').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        title: htmlDecode(window.Resources.AddToThisReport)
    });

    $('#btnConfirmRemoveProcedureCancel').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('#dialogConfirmRemoveProcedure').dialog('close');
    });

    $('#btnConfirmAddProcedureCancel').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('#dialogConfirmAddProcedure').dialog('close');
    });
    
    var RemoveOrderProcedureFromReport = function (orderProcedureUID) {
        $('#procNotInReport li.procedureReportTitle.none').hide();
        procedureToRemoveFromReport.find('span.procHasReport').remove();
        procedureToRemoveFromReport.clone().appendTo('#procNotInReport');
        procedureToRemoveFromReport.remove();

        forOrder_ProcedureUIDs = forOrder_ProcedureUIDs.replace(orderProcedureUID + "_", "");
        if (addOrder_ProcedureUIDs.indexOf("|" + orderProcedureUID + "|_") < 0) {
            removeOrder_ProcedureUIDs += "|" + orderProcedureUID + "|_";
            createCookie('removeOrder_ProcedureUIDs' + viewbagUniquePrefix, removeOrder_ProcedureUIDs, 7);
        }
        addOrder_ProcedureUIDs = addOrder_ProcedureUIDs.replace("|" + orderProcedureUID + "|_", "");
        createCookie('addOrder_ProcedureUIDs' + viewbagUniquePrefix, addOrder_ProcedureUIDs, 7);

        $('#dialogConfirmRemoveProcedure').dialog('close');

        $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
            tooltipClass: 'jqueryTooltip',
            content: function () {
                return $(this).prop('title');
            },
            position: {
                my: "left top",
                at: "left bottom"
            },
            close: function (event, ui) {
                $('.jqueryTooltip').remove();
            },
            show: function (event, ui) {
                $('.jqueryTooltip').remove();
            }
        });
    };


    $('#btnConfirmRemoveProcedureOk').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();

        var orderProcedureUID = procedureToRemoveFromReport.find('.number').text();

        var currentLockedRecordID = $('span#lockableRecordID').text();
        ReportSharedFunctions.RemoveOrderProcedureFromLock(orderProcedureUID).done(function (e) {
            $('span#lockableRecordID').text(currentLockedRecordID.replace("|" + orderProcedureUID + "|_", ""));
            RemoveOrderProcedureFromReport(orderProcedureUID);
        });
    });

    var AddOrderProcedureToReport = function (orderProcedureUID) {

        procedureToAddToReport.clone().appendTo('#procInReport');
        procedureToAddToReport.remove();

        if ($('#procNotInReport li.procedureItem, #procNotInReport li.procedureItemWithRating, #procNotInReport li.procedureItemWithRatingv1').length == 0) {
            $('#procNotInReport').append('<li style="font-weight: bold;" class="procedureReportTitle none">' + window.Resources.None + '</li>');
        }

        forOrder_ProcedureUIDs += orderProcedureUID + "_";
        addOrder_ProcedureUIDs += "|" + orderProcedureUID + "|_";
        removeOrder_ProcedureUIDs = removeOrder_ProcedureUIDs.replace("|" + orderProcedureUID + "|_", "");

        createCookie('addOrder_ProcedureUIDs' + viewbagUniquePrefix, addOrder_ProcedureUIDs, 7);
        createCookie('removeOrder_ProcedureUIDs' + viewbagUniquePrefix, removeOrder_ProcedureUIDs, 7);

        $('#dialogConfirmAddProcedure').dialog('close');

        $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
            tooltipClass: 'jqueryTooltip',
            content: function () {
                return $(this).prop('title');
            },
            position: {
                my: "left top",
                at: "left bottom"
            },
            close: function (event, ui) {
                $('.jqueryTooltip').remove();
            },
            show: function (event, ui) {
                $('.jqueryTooltip').remove();
            }
        });
    };

    function responseAddOPToReportSuccess(currentLockedRecordID, orderProcedureUID) {
        $('span#lockableRecordID').text(currentLockedRecordID + "|" + orderProcedureUID + "|_");
        AddOrderProcedureToReport(orderProcedureUID);
    }

    $('#btnConfirmAddProcedureOk').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();

        var orderProcedureUID = procedureToAddToReport.find('.number').text();
        var currentLockedRecordID = $('span#lockableRecordID').text();
        var resReqAddToLock = AddOrderProcedureToLock(orderProcedureUID).done(function (e) {
            const fc = new URLSearchParams(window.location.search).get('fc') * 1;
            window.addLocks(fc, e.Locks.LockUIDs);
            if (resReqAddToLock.responseJSON && !resReqAddToLock.responseJSON.Locks.NewLock)
                window.showLockedFileDialog(resReqAddToLock.responseJSON, null, responseAddOPToReportSuccess.bind(this, currentLockedRecordID, orderProcedureUID));
            else
                responseAddOPToReportSuccess(currentLockedRecordID, orderProcedureUID)
        });
    });

    $.contextMenu("destroy",{selector: 'ul#procInReport li.procedureItem, ul#procInReport li.procedureItemWithRating, ul#procInReport li.procedureItemWithRatingv1'});

    $.contextMenu({
        selector: 'ul#procInReport li.procedureItem, ul#procInReport li.procedureItemWithRating, ul#procInReport li.procedureItemWithRatingv1',
        events: {
            show: function (opt) {
                if ($('ul#procInReport li.procedureItem, ul#procInReport li.procedureItemWithRating, ul#procInReport li.procedureItemWithRatingv1').length <= 1 || validatedReport || readOnly) {
                    return false;
                }
                else {
                    procedureToRemoveFromReport = $(this);
                }
            }
        },
        build: function ($trigger, e) {
            return {
                callback: function (key, options) {
                    if (key == "remove") {
                        var procedureClone = procedureToRemoveFromReport.clone();
                        $('#confirmRemoveProcedureHolder').empty();
                        procedureClone.appendTo('#confirmRemoveProcedureHolder');

                        $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
                            tooltipClass: 'jqueryTooltip',
                            //track: true,
                            content: function () {
                                return $(this).prop('title');
                            },
                            position: {
                                my: "left top",
                                at: "left bottom"
                            },
                            close: function (event, ui) {
                                $('.jqueryTooltip').remove();
                            },
                            show: function (event, ui) {
                                $('.jqueryTooltip').remove();
                            }
                        });

                        $('#dialogConfirmRemoveProcedure').dialog('open');
                    }
                },
                items: {
                    "remove": {
                        name: window.Resources.RemoveFromThisReport,
                        disabled: function () {
                            if ($('ul#procInReport li.procedureItem, ul#procInReport li.procedureItemWithRating, ul#procInReport li.procedureItemWithRatingv1').length <= 1 || validatedReport || readOnly) {
                                return true;
                            }
                            return false;
                        }
                    }
                }
            }
        }
    });

    $.contextMenu("destroy",{selector: 'ul#procNotInReport li.procedureItem, ul#procNotInReport li.procedureItemWithRating, ul#procNotInReport li.procedureItemWithRatingv1' });

    $.contextMenu({
        selector: 'ul#procNotInReport li.procedureItem, ul#procNotInReport li.procedureItemWithRating, ul#procNotInReport li.procedureItemWithRatingv1',
        events: {
            show: function (opt) {
                if ($(this).find('.procIsLocked').length > 0 || $(this).find('.procIsValidated').length > 0 || $(this).find('.procIsDictated').length > 0 || validatedReport || readOnly) {
                    return false;
                }
                else {
                    procedureToAddToReport = $(this);
                }
            }
        },
        build: function ($trigger, e) {
            return {
                callback: function (key, options) {
                    if (key == "add") {
                        var procedureClone = procedureToAddToReport.clone();
                        $('#confirmAddProcedureHolder').empty();
                        procedureClone.appendTo('#confirmAddProcedureHolder');

                        $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
                            tooltipClass: 'jqueryTooltip',
                            //track: true,
                            content: function () {
                                return $(this).prop('title');
                            },
                            position: {
                                my: "left top",
                                at: "left bottom"
                            },
                            close: function (event, ui) {
                                $('.jqueryTooltip').remove();
                            },
                            show: function (event, ui) {
                                $('.jqueryTooltip').remove();
                            }
                        });

                        $('#dialogConfirmAddProcedure').dialog('open');
                    }
                },
                items: {
                    "add": {
                        name: window.Resources.AddToThisReport,
                        disabled: function () {
                            if ($(this).find('.procIsLocked').length > 0 || $(this).find('.procIsValidated').length > 0 || $(this).find('.procIsDictated').length > 0 || validatedReport || readOnly) {
                                return true;
                            }
                            return false;
                        }
                    }
                }
            }
        }
    });

    if(userHasSpeechRecognition && useG2Speech)
    {
        $('#subPageContent').on('click', '.btnCopyPreviousReportToG2', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            var text = $(this).parent().find('textarea.hiddenContent').val();
            var guid = reportGUID;
            $.ajax({
                type: 'POST',
                data: {
                    GUID: guid,
                    ReportContent: htmlEncode($.trim(text))
                },
                async: false,
                url: '/legacy/Reports/CopyReportToG2Speech',
                success: function (data) {
                }
            });
        });

        $('#hasG2Speech').text("true");
        $('#startSpeechRecognition').on('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (!$(this).hasClass('disabled')) {
                $(this).addClass('disabled');
                launchSpeechXHR?.abort();
                clearTimeout(pollG2Timeout);
                firstSetupG2 = true;
                launchG2Speech(true);
            }
        });

        $('#getSpeechRecognitionText').on('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();

            $.ajax({
                type: "GET",
                url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                async: false,
                data: {
                    GUID: reportGUID,
                    Order_UID: Model.OrderID
                },
                timeout: 15000,
                success: function (data) {
                    if (data.AllOk) {
                        if (data.ReportGUID)
                        {
                            reportGUID = data.ReportGUID;
                        }
                        tinymce.activeEditor.setContent(data.Result);
                        clearTimeout(pollG2Timeout);
                        $('#startSpeechRecognition').removeClass('disabled');
                    }
                    else if (data.ErrorG2) {
                        alert(data.ErrorMessage);
                    }
                }
            });
        });

        if(startSpeechRecognition)
        {
            launchG2Speech();
        }
    }

    if(toShowScannedOrderOnReport)
    {
        $('li#openOrderDocumentTab a').trigger('click');
    }

    if (!toShowScannedOrderNextToReport || Model.Validated || Model.ReadOnly || Model.Screening)
    {
        $('#showOrCloseOrderDocuments').hide();

        var ResizeOrderReportFields = function (e) {
            $('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());
            return false;
        };
    }
    else
    {
        $('#showOrCloseOrderDocuments').on('click', function (e) {
            if ($(this).hasClass('hiddenOrderDocuments')) {
                $(this).removeClass('hiddenOrderDocuments');
                $('#orderReportWrapper').removeClass('orderDocumentsNotShown');
                $('#scannedOrderTab').removeClass('orderDocumentsNotShown');
            }
            else {
                $(this).addClass('hiddenOrderDocuments');
                $('#orderReportWrapper').addClass('orderDocumentsNotShown');
                $('#scannedOrderTab').addClass('orderDocumentsNotShown');
            }
        });

        var ResizeOrderReportFields = function (e) {
            $('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());

            var maxHeight = $('#subPageContent').height() - ($('#breadcrumb').height() + $('#subPageContent h2').height() + $('#subPageContent div#subContent div.subField').height() + 132);
            $('#scannedOrderTab').css('max-height', maxHeight + 'px');
            $('#orderReportWrapper').css('max-height', maxHeight + 'px');
        }

        $(window).resize(function (e) {
            setTimeout(function () {
                ResizeOrderReportFields();
            }, 300);
        });

        setTimeout(function () {
            ResizeOrderReportFields();
        }, 300);
    }

    if(isAssistentRadiologist)
    {
        var ShowPopupChooseSupervisor = function (printReport) {
            $.ajax({
                type: "GET",
                url: "/legacy/Session/GetLastChosenSupervisors",
                async: false,
                success: function (data) {
                    if (data.Supervisors.length > 0) {
                        $('#previousChosenSupervisors li.previousChosenSupervisor').remove();
                        for (var i = data.Supervisors.length - 1 ; i >= 0 ; i--) {
                            var li = '<li class="previousChosenSupervisor">- ' + data.Supervisors[i].Name + '<input type="hidden" class="previousChosenSupervisorID" value="' + data.Supervisors[i].ID + '" /></li>';
                            $('#previousChosenSupervisors').append(li);
                        }
                        $('#noPreviousChosenSupervisors').hide();
                    }
                    else {
                        $('#noPreviousChosenSupervisors').show();
                    }
                }
            });

            $('#popupNewChoosenSupervisorID').val("");

            $('#btnChooseSupervisor').attr('disabled', true);

            $('#divChooseSupervisor').data('printReport', printReport).dialog('open');
        };

        $('#btnChooseSupervisor').on('click', function (e) {
            var newSupervisorID = $('#popupNewChoosenSupervisorID').val();
            var oldSupervisorID;
            var selectedSupervisorID;

            if (newSupervisorID) {
                selectedSupervisorID = newSupervisorID;
            }
            else {
                oldSupervisorID = $('.previousChosenSupervisor.active').find('.previousChosenSupervisorID').val();
                if (oldSupervisorID) {
                    selectedSupervisorID = oldSupervisorID;
                }
            }

            if (selectedSupervisorID) {
                $.ajax({
                    type: "POST",
                    url: "/legacy/Session/AddChosenSupervisorToSession",
                    async: false,
                    data: {
                        Supervisor_UID: selectedSupervisorID
                    },
                    success: function (data) {
                        $('#divChooseSupervisor').dialog('close');
                        var printReport = $("#divChooseSupervisor").data('printReport');
                        SaveAndClose(selectedSupervisorID, printReport);
                    }
                });
            }

        });

        $('body').on('click', 'li.previousChosenSupervisor', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            $('li.previousChosenSupervisor').removeClass('active');
            $(this).addClass('active');
            $('#popupChooseSupervisor').val("");
            $('#popupNewChoosenSupervisorID').val("");
            $('#btnChooseSupervisor').prop('disabled', false);
        });
    }

    window.onNavigateForRazor = async () => {
        window.clearRefreshTimeout();
        await window.closeActiveSpeechAsPromise();
    }
}
